import { Injectable } from '@angular/core';

@Injectable()
export class CueTableService {
    constructor() {}

    datasource: any[];
    configs: any;

    setDataSource(dataList: any[]) {
        this.datasource = dataList;
    }

    setConfigs(configs: any) {
        this.configs = configs;
    }

    getDatasource() {
        return this.datasource;
    }

    getConfigs() {
        return this.configs;
    }
}
